/* eslint-disable no-debugger */
import { Fragment } from 'react';

import Headings from '@usas/ui-web/components/headings/Headings';
import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import useNewClubRegistrationStaffDetail from './UseNewClubRegistrationStaffDetail';

import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';

import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';


const NewClubRegistrationStaffDetail = () => {
    const {
        clubRegistrationNavState,
        formState,
        errorState,
        onFormValueChanged,
        onValueTextPairChanged,
        onAddClicked,
        onCancelClicked,
        setFormData,
        handleSubmit,
        coachTypeCodeOptions,
        HEAD_COACH_ORG_ROLE_ID,
        ASSISTANT_COACH_ORG_ROLE_ID,
        AGE_GROUP_COACH_ORG_ROLE_ID,
        SENIOR_COACH_ORG_ROLE_ID,
        SECOND_COACH_ORG_ROLE_ID,
        orgRoleId,
        orgRoleName
    } = useNewClubRegistrationStaffDetail();

    return (
        <LeftNav title={ClubRegistrationConstants.LEFT_NAV_TITLE} state={clubRegistrationNavState} validateBeforeRedirect={false}>
            <div className="row">
                <div className="col-xs-12">
                    <Headings.H3>Club Staff</Headings.H3>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 usas-extra-top-margin">
                    <Headings.H6>Add {orgRoleName}</Headings.H6>
                </div>
            </div>

            <form onSubmit={handleSubmit} noValidate>
                <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                    <div className="col-xs-12 col-sm-6 col-md-4">
                        <SearchMemberWithLscPopup
                            formState={formState}
                            errorState={errorState}
                            setFormData={setFormData}
                            onFormValueChanged={onFormValueChanged} />
                    </div>
                    {
                        orgRoleId === HEAD_COACH_ORG_ROLE_ID || 
                        orgRoleId === ASSISTANT_COACH_ORG_ROLE_ID || 
                        orgRoleId === AGE_GROUP_COACH_ORG_ROLE_ID || 
                        orgRoleId === SENIOR_COACH_ORG_ROLE_ID ||
                        orgRoleId === SECOND_COACH_ORG_ROLE_ID ?
                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <Dropdown
                                label="Full Time / Part Time Coach*"
                                name="coachTypeCode"
                                options={coachTypeCodeOptions}
                                value={formState.coachTypeCode}
                                error={errorState.coachTypeCode}
                                message={errorState.coachTypeCode}
                                showEmptySelection={false}
                                isLoading={false}
                                onChange={(newValue, newValueLabel, e) => {
                                    e && e.target && e.target.value &&
                                        onValueTextPairChanged(newValue, 'coachTypeCode', newValueLabel, 'coachTypeCodeName');
                                }} />
                        </div>
                        : <Fragment />
                    }
                </div>
                {errorState.apiError &&
                    <div className="row">
                        <div className="col-xs-12 usas-extra-top-margin">
                            <p className={global.ErrorMessage}>{errorState.apiError}</p>
                        </div>
                    </div>
                }
                {errorState.uniqueRoleError &&
                    <div className="row">
                        <div className="col-xs-12 usas-extra-top-margin">
                            <p className={global.ErrorMessage}>{errorState.uniqueRoleError}</p>
                        </div>
                    </div>
                }
                {errorState.conflictingRolesError &&
                    <div className="row">
                        <div className="col-xs-12 usas-extra-top-margin">
                            <p className={global.ErrorMessage}>{errorState.conflictingRolesError}</p>
                        </div>
                    </div>
                }
                <div className="row usas-extra-top-margin usas-extra-bottom-margin">
                    <div className="col-xs-12 usas-extra-top-margin">
                        <PrimaryButton type="button" onClick={onAddClicked}>Add Staff</PrimaryButton>&nbsp;
                        <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
                    </div>
                </div>
            </form>
        </LeftNav>);
}

export default NewClubRegistrationStaffDetail;